import debug from 'debug';

import { LogService } from './LogService';

const log = debug('LogService:Search');

export class Search extends LogService {
	
	// Log that the user navigated from search to a catalog
	/**
	 * @param {string} [navigateTo]
	 */
	Navigate(navigateTo) {
		if (navigateTo === undefined) navigateTo = 'catalog';

		this.LaunchDarklyFeature().then(() => {
			let url = '/api/web/LogDoNavigate';
			let body = this.settings;
	
			body.from = 'search';
			body.to = navigateTo;
			this.Post({
				url: url,
				body: body
			})
		});
	}

	SearchField(options) {
		if (!options || !options.searchID || !options.searchTerm) {
			log('LogDoSearch() options error!', options);
			return;
		}

		this.LaunchDarklyFeature().then(() => {
			let url = '/api/web/LogDoSearch';
			let body = this.Extend(this.settings, options);
			this.Post({
				url: url,
				body: body
			})
		});
	}

	SearchResult(options) {
		if (!options || !options.offerIDs || !options.searchID) {
			log('LogViewAdvertPage() options error!', options);
			return;
		}

		this.LaunchDarklyFeature().then(() => {
			let url = '/api/web/LogViewSearch';
			let body = this.Extend(this.settings, options);
			this.Post({
				url: url,
				body: body
			})
		});
	}

}

export let search = new Search();
